import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import PopperDropDown from '../PopperDropDown';
import IconButtonUI from '../IconButton';
export var IconButton = styled(IconButtonUI).attrs({
  color: 'secondary'
}).withConfig({
  displayName: "ui-kit-IconButton",
  componentId: "ui-kit-1klwk1m"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n"], ["\n  width: 24px;\n  height: 24px;\n"])));
export var PopperDropDownStyled = styled(PopperDropDown).withConfig({
  displayName: "ui-kit-PopperDropDownStyled",
  componentId: "ui-kit-40ndbi"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & .menu-wrap {\n    max-height: 256px;\n  }\n"], ["\n  & .menu-wrap {\n    max-height: 256px;\n  }\n"])));
var templateObject_1, templateObject_2;